/* eslint-disable @angular-eslint/component-selector */

import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ProductListItem } from '@idealsupply/ngclient-webservice-inventory';

@Component({
  selector: 'product-thumbnail',
  templateUrl: './product-thumbnail.component.html',
  styleUrls: ['./product-thumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ProductThumbnailComponent {
  @Input()
  public item: ProductListItem | undefined;

  @HostBinding('class.noimage')
  public get noimage(): boolean {
    return !this.item?.imageUrl;
  }
}
